function pageAccountRegister() {
  $("button[id^='button-custom-field']").on("click", function () {
    var element = this;

    $("#form-upload").remove();

    $("body").prepend(
      '<form enctype="multipart/form-data" id="form-upload" style="display: none;"><input type="file" name="file" /></form>'
    );

    $("#form-upload input[name='file']").trigger("click");

    if (typeof timer != "undefined") {
      clearInterval(timer);
    }

    timer = setInterval(function () {
      if ($("#form-upload input[name='file']").val() != "") {
        clearInterval(timer);

        $.ajax({
          url: "index.php?route=tool/upload",
          type: "post",
          dataType: "json",
          data: new FormData($("#form-upload")[0]),
          cache: false,
          contentType: false,
          processData: false,
          beforeSend: function () {
            $(element).button("loading");
          },
          complete: function () {
            $(element).button("reset");
          },
          success: function (json) {
            $(element).parent().find(".text-danger").remove();

            if (json["error"]) {
              $(node)
                .parent()
                .find("input")
                .after('<div class="text-danger">' + json["error"] + "</div>");
            }

            if (json["success"]) {
              alert(json["success"]);

              $(element).parent().find("input").val(json["code"]);
            }
          },
          error: function (xhr, ajaxOptions, thrownError) {
            alert(
              thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText
            );
          },
        });
      }
    }, 500);
  });
}
